var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-order",on:{"click":_vm.payment}},[_vm._v("查看更多财务分析内容")])])
}
var staticRenderFns = []

export { render, staticRenderFns }